import { render, staticRenderFns } from "./ModificaBarca.vue?vue&type=template&id=ef630890&scoped=true&"
import script from "./ModificaBarca.vue?vue&type=script&lang=js&"
export * from "./ModificaBarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef630890",
  null
  
)

export default component.exports